var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewRequestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2745_2448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.32283 11.5312H1.40625C0.888492 11.5312 0.46875 11.1115 0.46875 10.5938V1.40625C0.46875 0.888492 0.888492 0.46875 1.40625 0.46875H5.90625C6.16512 0.46875 6.39949 0.57368 6.56916 0.743344L7.50666 1.68084C7.6763 1.85048 7.78125 2.08486 7.78125 2.34375V4.92607",
    stroke: "#F9F9F9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.93085 5.42779C10.297 5.06167 10.8906 5.06167 11.2567 5.42779C11.6228 5.7939 11.6228 6.38751 11.2567 6.75362L7.38172 10.6286C7.31377 10.6965 7.23579 10.7536 7.15048 10.7979L5.8377 11.4788C5.66117 11.5704 5.43858 11.5421 5.29044 11.394C5.14231 11.2459 5.11404 11.0233 5.20561 10.8467L5.88659 9.53397C5.93084 9.44868 5.98793 9.37068 6.05588 9.30273L9.93085 5.42779Z",
    stroke: "#F9F9F9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34375 4.03125H5.90625",
    stroke: "#F9F9F9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34375 5.90625H5.90625",
    stroke: "#F9F9F9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34375 7.78125H4.03125",
    stroke: "#F9F9F9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2745_2448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewRequestIcon);
export default __webpack_public_path__ + "static/media/NewRequestIcon.94761c8467b7849aa9c98276ef062662.svg";
export { ForwardRef as ReactComponent };